import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import { Col, Row } from '@vds/grids';
import { TextLink } from '@vds/buttons';

import './cart.css';
import { Title, Body } from '../../../../common/Typography/index';
import { apiUrls } from '../../../../../constants/apiUrl';
import { getFlowType, isMobile, isMVA, getLTEUpgrade } from '../../../../common/Helpers/index';
import { getProductRefData } from '../../../../../utils/plansReference';
import { goToProcessStep } from '../../../../../redirection';
import { mvaLinkApiCall } from '../../../../common/MVAApiCall';
import { store } from '../../../../../configureStore';
import * as actionTypes from '../../../../../pages/ProgressivePlans/@Redux/actionTypes';
import IPILink from '../../../../NextGen/ImportantPlanInfo/index';

export default class dueMonthly extends Container {
  constructor(props) {
    super(props);
    this.planInfo = '';
    this.flowType = getFlowType();
    this.isMobile = isMobile();
    this.mfapp = isMVA();
    this.npaNXXValue = '';
  }

  componentDidMount() {
    this.setState({ termsAndConditionsModalVisible: false });
  }

  componentDidUpdate() {
    if (this.state.termsAndConditionsModalVisible) {
      const closeIcon = document.getElementById('close-button');
      if (closeIcon) {
        closeIcon.focus();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.cartDetails !== nextProps.cartDetails) {
      const objCart =
        nextProps.cartDetails &&
        nextProps.cartDetails.map((SDList) => this.renderHTMLContent(SDList, this.props.plansReferenceData, this.props.pageName));
      return objCart;
    }
  }

  editCartItem = () => {
    store.dispatch({ type: actionTypes.UPDATE_PLANS_ACCORD_STATUS, response: true });
    goToProcessStep(this.props.currentView, this.props.history, false, false, true);
  };

  broadBandInfoClick = () => {
    if (this.mfapp) {
      mvaLinkApiCall(this.importantBroadBandMVA ? this.importantBroadBandMVA[0] : apiUrls().mfAppBroadBandUrl);
    } else {
      window.open(this.importantBroadBand ? this.importantBroadBand[0] : apiUrls().broadBandUrl, '_blank');
    }
  };

  renderHTMLContent = (SDList, plansReferenceData, pageName) => {
    const { ltePlans, broadbandInfoTitle } = this.props;
    let dueTodayListObj = this.props?.dueTodayList && (this.props?.dueTodayList).filter((item) => item.itemType === 'DEVICE');
    dueTodayListObj = dueTodayListObj?.[0];
    this.planInfo = dueTodayListObj && getProductRefData(dueTodayListObj?.sorId, dueTodayListObj?.productId, plansReferenceData);
    let imageUrl = '';
    if (dueTodayListObj?.imageUrlMap?.largeImage) {
      imageUrl = dueTodayListObj?.imageUrlMap?.largeImage;
    } else if (this.planInfo && this.planInfo.length > 0) {
      imageUrl = this.planInfo[0].cartImageUrl;
    }

    this.planInfo = getProductRefData(SDList?.sorId, SDList?.productId, plansReferenceData);
    let planName;
    if (SDList?.name && SDList.itemType !== 'SUBSCRIPTION') {
      planName = SDList.name;
    } else if (this.planInfo && this.planInfo.length > 0) {
      if (this.flowType === 'LTE') {
        planName = this.planInfo[0].cart_Mly_lte;
      } else {
        planName = this.planInfo[0].cart_Mly_5g;
      }
    }

    let planInfo = {};
    if (ltePlans && ltePlans.plans && ltePlans.plans.length > 0 && ltePlans.plans[0].planSorId) {
      planInfo = getProductRefData(ltePlans.plans[0].planSorId, 0, plansReferenceData)?.[0];
    }
    this.importantProductinfo = getProductRefData('importantproduct', '', plansReferenceData);

    const isPlanType = SDList.itemType === 'PLAN' && !SDList?.isHomePhone;
    if (!isPlanType) return null;

    return (
      <div>
        <Row>
          <Col xs={9}>
            <div className="plansArea">
              <img className="dueTodayItemImage" src={imageUrl} alt="" />
              <div>
                <Body size="small">Plan</Body>
                <div className={`${this.isMobile ? '' : 'marginTop4'}`}>
                  <Title size="medium" primitive="h3">
                    {planName}
                  </Title>
                </div>
                <div className="marginTop4">
                  <div>
                    <Body primitive="p" size="large" aria-hidden="true">
                      <span className="fontWight400">
                        ${parseFloat(SDList.totalAmountWithDiscount)}
                        /mo
                      </span>
                    </Body>
                  </div>
                  {getLTEUpgrade() && planInfo.sorId && planInfo.currentPlan && planInfo.sorId === this.planInfo[0].sorId ? (
                    <div className="pad8 hellooo onlyLeftPad">{planInfo.currentPlan}</div>
                  ) : null}
                  <div className={`linkSection ${this.isMobile ? 'marginTop30' : 'marginTop8'}`}>
                    <Body size="small">
                      <IPILink />
                    </Body>
                    {broadbandInfoTitle && (
                      <div className={`${this.isMobile && 'marginTop10'}`}>
                        <Body size="small">
                          <TextLink
                            id="broadbandInfoTitleLink"
                            data-track='{"type": "link",  "name": "5G-importantPlanInformation"}'
                            analyticstrack="5G-importantPlanInformation"
                            onClick={() => this.broadBandInfoClick()}
                            onKeyPress={() => this.broadBandInfoClick()}
                            className=""
                            ariaLabel="Important broadband information  opens in a new tab"
                          >
                            <span className="fontWight400">{broadbandInfoTitle}</span>
                          </TextLink>
                        </Body>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={3} className={`${this.isMobile ? 'contentEnd marginTop6' : 'contentCenter marginTop24'}`}>
            {pageName === 'cart' && this.flowType && this.flowType !== '' && (
              <Body size="large">
                <TextLink
                  type="standAlone"
                  onClick={() => this.editCartItem()}
                  analyticstrack={`5G-addDevice_${SDList.name}`}
                  data-track="true"
                  ariaLabel={`${planName} plan Edit`}
                  id="Cart_Edit_Button"
                >
                  Edit
                </TextLink>
              </Body>
            )}
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    const { cartDetails, plansReferenceData, pageName } = this.props;
    return (
      <>
        <div>{cartDetails && cartDetails.map((SDList) => this.renderHTMLContent(SDList, plansReferenceData, pageName))}</div>
      </>
    );
  }
}
